import { useAuth } from "../contexts/AuthContext";
import { permissionsFactory } from "../utils/utils";
import Page403 from "./403";
import DataTableContainer from '../components/containers/DataTableContainer';
import StudentsTable from '../components/tables/StudentsTable';

const StudentsWaitingReenrollment = () => {
  const { permissions } = useAuth();
  const grantedPermissions = permissionsFactory(permissions);
  if (!grantedPermissions.canViewStudent) {
    return <Page403 />;
  }
  
  return (
    <DataTableContainer>
      <div style={{height: '93vh'}}>
        <StudentsTable 
          tableConfig={{
            context: 'reenrollment',
            studentsPath: 'students/waiting-reenrollment/',
            year: '2025',
            title: 'Aguardando rematrícula',
            baseQueryParams:{},
            columns: {
              status: true,
              last_reenrollment_log: true,
              reenrollment_status: true,
              last_log_created_days_ago: true,
            },
            pageSize: 15,
            showLogs: true,
            showGuardians: true,
            enableRowActions: true,
            columnVisibility: {
              external_id: false,
              status: false,
            }
          }}
          
                                                                 
        />
      </div>
    </DataTableContainer>
  );
};

export default StudentsWaitingReenrollment;
